const { __ } = wp.i18n;

const propertyIDFieldNode = document.querySelector( '.realpress-search-field.property_id' );
const realpressPropertyID = () => {
};

const getPropertyIDValue = () => {
	if ( ! propertyIDFieldNode ) {
		return '';
	}

	const propertyIDNode = propertyIDFieldNode.querySelector( 'input[name="property-id"]' );
	if ( propertyIDNode && propertyIDNode.value ) {
		return propertyIDNode.value;
	}

	return '';
};

const resetPropertyID = () => {
	if ( ! propertyIDFieldNode ) {
		return '';
	}

	propertyIDFieldNode.querySelector( 'input[name="property-id"]' ).value = '';
};

export { getPropertyIDValue, resetPropertyID };
export default realpressPropertyID;
